import { TableAlignment } from 'eone-ui/tables/table-constants';

export function TableRowCheckbox(props) {
  const changeValue = (value) => {
    if (typeof props.ChangeValue === 'function') {
      props.ChangeValue(props.FieldName, value);
    }
  };

  const updateValue = (value) => {
    if (typeof props.UpdateValue === 'function') {
      props.UpdateValue(props.FieldName, value);
    }
  };

  const changeAndUpdateValue = (e) => {
    const value = e.target.checked;
    changeValue(value);
    updateValue(value);
  };

  const getClass = () => {
    // let className = 'eone-ui-table-row-data';
    let className = '';
    switch (props.Alignment) {
      case TableAlignment.Center:
        className = `${className} eone-ui-table-row-data-center`;
        break;
      case TableAlignment.Right:
        className = `${className} eone-ui-table-row-data-right`;
        break;
    }
    return className;
  };

  const value = props.Row[props.FieldName];
  const label = value ? 'Yes' : 'No';

  return (
    <div className={getClass()} style={{ width: props.Width }}>
      {props.Editable ? (
        <input
          type="checkbox"
          disabled={props.Disabled}
          checked={value}
          onChange={changeAndUpdateValue}
        />
      ) : (
        label
      )}
    </div>
  );
}
